export const path = {
  notificationSettings: {
    route: "/notification-settings",
    link: () => path.notificationSettings.route,
  },
};
